var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44375",
    "data-name": "Group 44375",
    transform: "translate(-214 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44375-2",
    "data-name": "Group 44375",
    transform: "translate(214 32)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1844",
    "data-name": "Ellipse 1844",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#832fc6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user-filled",
    transform: "translate(219.333 35.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32360",
    "data-name": "Path 32360",
    d: "M6.75,23.887h6.062V22.372A2.124,2.124,0,0,0,10.69,20.25H8.872A2.124,2.124,0,0,0,6.75,22.372Z",
    transform: "translate(-6.75 -15.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32361",
    "data-name": "Path 32361",
    d: "M10.125,4.372A2.122,2.122,0,1,0,12.247,2.25,2.122,2.122,0,0,0,10.125,4.372Z",
    transform: "translate(-9.216 -2.25)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/usericon.86f882e6dee3a2defc263abfe00595fa.svg";
export { ForwardRef as ReactComponent };